/* eslint-disable react-hooks/exhaustive-deps */
import React, { useEffect, useState } from "react";
import useHeader from "../../hooks/useHeader";
import TaskCalendar from "./TaskCalendar";
import { toast } from "react-toastify";
import { getTasksCalender } from "../../stores/TaskStore";
import { useQuery } from "@tanstack/react-query";

export default function Tasks() {
  const { setHeader } = useHeader();
  useEffect(() => {
    setHeader("Task Calendar");
  }, []);

  const { data: tasks } = useQuery({
    queryFn: () => getTasksCalender(),
    queryKey: ["tasks", "calendar"],
  });

  return (
    <div>
      <TaskCalendar tasks={tasks} />
    </div>
  );
}
